import { capitalize, truncate } from "lodash";
import moment from "moment";
import { useLocation } from "react-router-dom";
import {
  ArtifactType,
  AssessmentSuggestionCitationFragment,
} from "types/graphql-schema";
import { TFLocationState } from "types/topicflow";

import IntegrationLogo from "@components/integration-logo/integration-logo";
import { IntegrationLogoType } from "@components/integration-logo/integration-logo-helpers";
import AppLink from "@components/link/link";
import TopicflowIcon from "@components/topicflow-icon/topicflow-icon";
import { removeCurrentYear, toWithBackground } from "@helpers/helpers";
import { titleCase } from "@helpers/string";

const integrationLogos = Object.values(IntegrationLogoType).map((type) =>
  type.toLowerCase(),
);

const artifactTypes = Object.values(ArtifactType);

const AssessmentContextSidebarSource = ({
  source,
}: {
  source: AssessmentSuggestionCitationFragment;
}) => {
  const location = useLocation<TFLocationState>();
  const icon = integrationLogos.includes(source.sourceProvider) ? (
    <IntegrationLogo
      type={capitalize(source.sourceProvider) as IntegrationLogoType}
      className="float-left mr-1.5 mt-0.5 w-4 h-4 border rounded"
    />
  ) : (
    <TopicflowIcon
      type="externalLink"
      className="float-left mr-1.5 mt-0.5 w-4 h-4 border rounded"
    />
  );

  if (source.sourceProvider === "topicflow") {
    let pathname = "";
    try {
      if (source.url) {
        const urlObj = new URL(source.url, window.location.origin);
        pathname = urlObj.pathname + urlObj.search + urlObj.hash;
      }
    } catch {
      pathname = source.url || "";
    }

    const showSidebar =
      artifactTypes.includes(source.sourceType as ArtifactType) ||
      source.sourceType === "meeting" ||
      source.sourceType === "meeting_transcript";

    return (
      <div>
        <AppLink
          className="text-gray-500 hover:text-gray-700"
          to={showSidebar ? toWithBackground({ pathname, location }) : pathname}
        >
          {icon}
          {titleCase(source.sourceType.split("_").join(" "))}:{" "}
          {truncate(source.title, { length: 100 })}
          {source.date && (
            <span className="text-gray-500 ml-1">
              ({removeCurrentYear(moment(source.date).format("ll"))})
            </span>
          )}
        </AppLink>
      </div>
    );
  }

  return (
    <div>
      <a
        target="_blank"
        className="text-gray-500 hover:text-gray-700"
        rel="noreferrer"
        href={source.url || ""}
      >
        {icon}
        {source.title}
      </a>
    </div>
  );
};

export default AssessmentContextSidebarSource;
